<!--
    描述：租赁通项目
    日期：2022/7/26
    创建人：李家宝
-->
<template>
  <div
    class="h100 audit operation-layout"
    :class="{
      sHeight: routeQuery == 'projectAuditMsg' || routeQuery == 'projectViewMsg'
    }"
  >
    <div class="header" v-if="!routeQuery">
      <el-row>
        <!--筛选条件-->
        <div class="searchBox" v-if="searchToggle">
          <el-form :model="searchForm" label-width="120px" size="small">
            <el-row>
              <el-col :span="5">
                <el-form-item label="求租标题：">
                  <el-input
                    v-model="searchForm.sname"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="发布企业：">
                  <el-input
                    v-model="searchForm.publisherName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="创建时间：">
                  <el-col :span="11">
                     <!-- :picker-options="startSendDatePicker" -->
                    <el-date-picker
                      v-model="searchForm.startDate"
                      type="date"
                      placeholder="开始时间"
                      value-format="yyyy-MM-dd"
                      clearable

                    >
                    </el-date-picker>
                  </el-col>
                  <el-col :span="2" class="text-center">~</el-col>
                  <el-col :span="11">
                           <!-- :picker-options="endSendDatePicker" -->
                    <el-date-picker
                      v-model="searchForm.endDate"
                      type="date"
                      placeholder="截止时间"
                      value-format="yyyy-MM-dd"
                      clearable

                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label-width="40px">
                  <el-button
                    type="primary"
                    class="btn-blue"
                    size="small"
                    @click="searchName"
                    >搜索
                  </el-button>
                  <el-button type="warning" size="small" @click="reset"
                    >重置
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--tab选项-->
        <el-col :span="24" class="toolbar mt20">
          <el-tabs v-model="typeState" @tab-click="tabChange(typeState)">
            <el-tab-pane name="1">
              <span slot="label"
                >交易中
                <!--<el-badge :value="normalNum" class="item"></el-badge>-->
              </span>
            </el-tab-pane>
            <el-tab-pane name="2">
              <span slot="label"
                >交易完成
                <!--<el-badge :value="endNum" class="item"></el-badge>-->
              </span>
            </el-tab-pane>
          </el-tabs>
          <div class="toolbar-right">
            <el-button
              type="primary"
              class="btn-blue ml10"
              size="small"
              @click="changeState"
            >
              筛选
              <i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
              <i v-else class="el-icon-caret-top ml5"></i>
            </el-button>
            <el-button
              type="primary"
              class="btn-blue ml10"
              icon="el-icon-refresh"
              @click="reset"
              size="small"
            ></el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--列表数据-->
    <div class="operation-main">
      <!-- 非请求参数 正常查看 -->
      <div class="w-table-layout w-table-page" v-if="!routeQuery">
        <div class="w-table-content" v-show="tableShow">
          <el-table
            :data="filiterData"
            height="100%"
            highlight-current-row
            row-key="id"
            border
            ref="table"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="70"
            ></el-table-column>
            <el-table-column
              prop="sname"
              label="求租标题"
              header-align="center"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="cityName"
              label="期望产品进场地址"
              header-align="center"
              align="center"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div>{{ scope.row.cityName }}</div>
                <div>{{ scope.row.detailAddress }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="productCategoryName"
              label="产品类别"
              align="center"
              header-align="center"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="statusName"
              label="项目状态"
              min-width="60"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="deadline"
              label="求租截止时间"
              header-align="center"
              align="center"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="pubReleaseTime"
              label="发布时间"
              header-align="center"
              align="center"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="publisherName"
              label="发布企业"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="publisherUserName"
              label="发布人"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column align="center" width="120">
              <template slot="header">操作</template>
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  round
                  plain
                  class="table-btn"
                  @click="audit(scope.row, 'view')"
                >
                  <svg-icon icon-class="form-look"></svg-icon>
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="w-table-footer" v-if="!routeQuery">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageList"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </div>

      <!--查看、审核 安招采-->
      <zulin-pro-audit
        v-if="routeQuery == 'projectAuditMsg'"
        ref="childContent"
        :rowData="rowData"
      ></zulin-pro-audit>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  zulinselectPageList,
  zulinselectPageNum
} from "api/modules/projectManagement";
import zulinProAudit from "./components/zulin-pro-audit";

export default {
  name: "zulin-project-list",
  components: { zulinProAudit },
  data() {
    return {
      typeState: "1", // tab 状态
      //标签红点
      allNum: 0, // 总数
      normalNum: 0, //交易中
      endNum: 0, //交易完成

      filiterData: [
        // { sname: '测试', id: '123456789' },
      ], // 列表数据
      loading: false,
      //筛选框
      searchForm: {
        tagSign: "1", //0;交易中，2已完成交易（1，取消，3异常   目前原型没给，不知是否用到）
        sname: "", //项目名称
        publisherName: "", // 发布企业
        startDate: "", //发布开始时间
        endDate: "" //发布结束时间

        // scope: '009',//聚易厅对应字段码
      },
      auditState: "0",
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      rowData: {}, // 表格操作当前行数据
      // startSendDatePicker: this.beginSendDate(),
      // endSendDatePicker: this.processSendDate(),
      searchToggle: true, //筛选控制
      tableShow: true, //表格显隐控制
      realNameLoading: false
    };
  },
  created() {
    // 如果是 返回的
    if (this.isBack) {
      if (this.$getSessionItem("activeTab")) {
        this.typeState = JSON.parse(this.$getSessionItem("activeTab"));
        // this.tabChange(this.typeState)

        // 移除 避免污染
        this.$removeSessionItem("activeTab");
      }

      if (this.$getSessionItem("params")) {
        this.searchForm = JSON.parse(this.$getSessionItem("params"));
        this.currentPage = JSON.parse(this.$getSessionItem("params")).current;
        this.pageSize = JSON.parse(this.$getSessionItem("params")).size;
        this.auditState = JSON.parse(this.$getSessionItem("params")).status;

        // 移除 避免污染
        this.$removeSessionItem("params");
      }
    }
    // 获取表格数据
    this.getData();
    // 查询标签数量
    // this.getTabNum();
  },
  filters: {
    isFlagFilter(status) {
      const statusMap = {
        0: "进行中",
        2: "已结束",
        3: "异常终止",
        1: "已撤回"
      };
      return statusMap[status];
    }
  },
  methods: {
    // 处理状态
    dealClass(data) {
      let msg = "";
      switch (data) {
        case 0:
          msg = "green-state";
          break;
        case 1:
          msg = "orange-state";
          break;
        case 2:
          msg = "gray-state";
          break;
        case 3:
          msg = "red-state";
          break;
      }
      return msg;
    },

    // 关闭loading
    realClose() {
      this.realNameLoading = false;
    },

    // tab切换
    tabChange(val) {
      this.currentPage = 1;
      this.pageSize = 10;
      if (val == "4") {
        this.searchForm.tagSign = "";
      } else {
        this.searchForm.tagSign = val;
      }
      // this.getTabNum();
      this.getData();
    },

    // 搜索
    searchName() {
      this.pageSize = 10;
      this.currentPage = 1;
      // this.getTabNum();
      this.getData();
    },

    //获取标签数量
    getTabNum() {
      zulinselectPageNum({
        // scope: this.searchForm.scope
      }).then(res => {
        if (res.operationCode == 1) {
          this.allNum = parseInt(res.data.allNum);
          this.normalNum = parseInt(res.data.normalNum);
          this.endNum = parseInt(res.data.endNum);
          this.abnormalEndNum = parseInt(res.data.abnormalEndNum);
        }
      });
    },

    //获得列表数据
    getData(isBack) {
      let params = Object.assign({}, this.searchForm);
      this.loading = true;
      // 分页参数
      params.current = this.currentPage;
      params.size = this.pageSize;
      params.currentUserId = this.userInfo.id;
      zulinselectPageList(params).then(res => {
        if (res.operationCode == 1) {
          this.loading = false;
          this.filiterData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
          if (this.searchForm.tagSign == 1) {
            this.normalNum = res.data.total;
          } else {
            this.endNum = res.data.total;
          }
        }
      });
    },

    //筛选框重置
    reset() {
      this.searchForm.sname = "";
      this.searchForm.publisherName = "";
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      this.pageSize = 10;
      this.currentPage = 1;
      // this.getTabNum();
      this.getData();
    },

    // 点击审核
    audit(data, type) {
      let queryType = "projectAuditMsg"; // 审核页面，支持审核及查看
      let params = Object.assign({}, this.searchForm);
      params.current = this.currentPage;
      params.size = this.pageSize;
      params.type = this.searchForm.tagSign;

      // 存值
      this.$setSessionItem("params", JSON.stringify(params));
      this.$setSessionItem("activeTab", JSON.stringify(this.typeState));

      // 列表数据
      this.rowData = data;

      // 页面跳转
      this.$router.push({
        name: "zulin-project-list",
        query: {
          type: queryType,
          mode: type
        }
      });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      // this.getTabNum();
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.getTabNum();
      this.getData();
    },

    // // 开始时间的 pickOption
    // beginSendDate() {
    //   let that = this;
    //   return {
    //     disabledDate(time) {
    //       let endTime = "";
    //       endTime = that.searchForm.endDate;
    //       if (endTime != "") {
    //         // endTime = endTime.getTime() + 86400000
    //       }
    //       if (endTime) {
    //         return bmElementTimeOptins.limitDateBefore(time, endTime, true);
    //       } else {
    //         return time.getTime() > Date.now();
    //       }
    //     }
    //   };
    // },
    // // 结束时间的 pickOption
    // processSendDate() {
    //   let that = this;
    //   return {
    //     disabledDate(time) {
    //       let startTime = "";
    //       startTime = that.searchForm.startDate;
    //       if (startTime) {
    //         let nowTime = Date.now();
    //         return bmElementTimeOptins.limitDateInRange(
    //           time,
    //           startTime,
    //           nowTime,
    //           true
    //         );
    //       } else {
    //         return time.getTime() > Date.now();
    //       }
    //     }
    //   };
    // },
    // 切换状态
    changeState() {
      this.searchToggle = !this.searchToggle;
    }
  },
  computed: {
    ...mapState("app", {
      clientSize: state => state.clientSize,
      isBack: state => state.isBack,
    }),

    ...mapState("menu", {
      roleBtns: state => state.roleBtns
    }),

    ...mapState("user", { userInfo: state => state.userInfo }),

    ...mapState("dict", {
      zmlx: state => state.zmlx
    }),
    routeQuery() {
      return this.$route.query.type;
    }
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
    },

    // 监听路由参数 --- 回到主界面时刷新查询
    $route(params) {
      let arr = Object.keys(params.query);
      if (arr.length === 0) {
        // this.getTabNum();
        this.getData();
      }
    }
  }
};
</script>

<style scoped lang="less">
.audit {
  .searchBox {
    padding-top: 8px;
  }

  /deep/ .more-layout {
    top: 55px;
    right: 370px;
  }

  /deep/ .el-tabs__item {
    width: 100px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f0f0f0;
    border-radius: 3px 3px 0px 0px;
    color: #666;
    margin-right: 20px;
    padding: 0;

    .el-tabs__header {
      border-bottom: 1px solid #2671cc;
    }
  }

  /deep/ .el-tabs__item.is-active {
    color: #fff;
    background-color: #2671cc !important;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: #2671cc;
    height: 1px;
    z-index: 999;
  }

  /deep/ .el-tabs__active-bar {
    background-color: transparent;
  }

  .auditMsg {
    color: #2671cc;
    cursor: pointer;
  }

  .green,
  .red,
  .orange {
    display: inline-block;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    font-size: 12px;
    border-radius: 5px;
  }

  .green {
    background: #e9f6f2;
    border: 1px solid #bff5e5;
    color: #39c098;
  }

  .red {
    background: #feeff0;
    border: 1px solid #fde2e2;
    color: #f56c6c;
  }

  .orange {
    background: #fdf6ec;
    border: 1px solid #faecd8;
    color: #e7a23c;
  }

  .toolbar {
    position: relative;

    .toolbar-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  /deep/ .el-table__header-wrapper {
    tr > th {
      padding: 6px 0 !important;
      height: 50px !important;
    }
  }

  .item {
    position: absolute !important;
    right: -15px;
  }
}

.sHeight {
  padding: 0;
}

.colorred {
  color: #f56c6c;
}
</style>
